import type { CombatStats } from '@/domain/combat/types';
import type { MutationId } from './types';
import { MUTATION_CATALOG } from './catalog';

/** Aplica todas as mutations escolhidas sobre stats base. */
export function applyMutations(base: CombatStats, mutationIds: ReadonlyArray<MutationId>): CombatStats {
  let s: CombatStats = { ...base };
  for (const id of mutationIds) {
    const def = MUTATION_CATALOG[id];
    if (!def) continue;
    if (def.delta) {
      if (def.delta.maxHp) s.maxHp = Math.max(20, s.maxHp + def.delta.maxHp);
      if (def.delta.damage) s.damage = Math.max(1, s.damage + def.delta.damage);
      if (def.delta.speed) s.speed = Math.max(40, s.speed + def.delta.speed);
      if (def.delta.attackSpeed) s.attackSpeed = s.attackSpeed * def.delta.attackSpeed;
      if (def.delta.critChance) s.critChance = Math.min(1, s.critChance + def.delta.critChance);
    }
    if (def.passive) {
      switch (def.passive) {
        case 'thornedHide': s.thornedHide = true; break;
        case 'shield': s.shield = true; break;
        case 'burnTouch': s.burnTouch = true; break;
        case 'iceTouch': s.iceTouch = true; break;
        case 'lifesteal': s.lifesteal = true; break;
        case 'doubleStrike': s.doubleStrike = true; break;
        case 'phoenix': s.phoenix = true; break;
        case 'overload': s.overload = true; break;
        case 'bloodlust': s.bloodlust = true; break;
        case 'aether':
          s.aether = true;
          s.burnTouch = true;
          s.iceTouch = true;
          break;
        case 'regen':
          // efeito tickado em runtime, não muta stats
          break;
      }
    }
  }
  return s;
}
